import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Button from 'component/Button'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Select from 'component/Select/Select'
import CloseIconSVG from 'component/svgComponents/close'


const SideFilterDemarcate = (props) => {
  const { changeFilterValues, setIsOpen, visible, translate } = props

  const filterStatusOptions = [
    {
      value: 0,
      param: [0, 1],
      label: translate('demarcate.justifies.filter.option.all'),
    },
    { value: 1, param: [0], label: translate('active') },
    { value: 2, param: [1], label: translate('inactive') },
  ]

  const filterTypeOptions = [
    {
      value: 0,
      param: ['request', 'reproval'],
      label: translate('demarcate.justifies.filter.option.all'),
    },
    {
      value: 1,
      param: ['request'],
      label: translate('demarcate.justifies.type.request'),
    },
    {
      value: 2,
      param: ['reproval'],
      label: translate('demarcate.justifies.type.reproval'),
    },
  ]

  const [statusValue, setStatusValue] = useState(filterStatusOptions[0])
  const [typeValue, setTypeValue] = useState(filterTypeOptions[0])

  function handleStatusOption(value) {
    setStatusValue({
      ...filterStatusOptions[value],
    })
  }

  function handleTypeOption(value) {
    setTypeValue({
      ...filterTypeOptions[value],
    })
  }

  function handleChangeFilter() {
    changeFilterValues({
      type: typeValue,
      status: statusValue,
    })
    setIsOpen()
  }
  return (
    <>
      {visible && (
        <>
          <div className='bg-filter' />
          <div className='right-filter-container'>
            <CloseIconSVG className="right-filter-svg" onClick={setIsOpen} />
            <h3 className='margin-bottom-triple'>
              <strong>{translate('commonReport.filters')}</strong>
            </h3>
            <Row className='w-100'>
              <Col>
                <Select
                  fill
                  required
                  label={translate('type')}
                  options={filterTypeOptions}
                  value={typeValue || ''}
                  placeholder={translate('irc.choose-tip')}
                  onChange={({ value }) => handleTypeOption(value)}
                  handleStatusOption
                />
              </Col>
            </Row>
            <Row className='w-100'>
              <Col>
                <Select
                  fill
                  required
                  label={translate('status')}
                  options={filterStatusOptions}
                  value={statusValue || ''}
                  placeholder={translate(
                    'transferenceRequestFilterFragment.selectStatus'
                  )}
                  onChange={({ value }) => handleStatusOption(value)}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className='margin-bottom margin-top no-padding'>
                <Button
                  className='btn btn-primary full-w'
                  onClick={() => handleChangeFilter()}
                  text={translate('btn.filter')}
                  disabled={
                    statusValue === undefined || typeValue === undefined
                  }
                />
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  )
}

SideFilterDemarcate.propTypes = {
  changeFilterValues: PropTypes.func.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  translate: PropTypes.func.isRequired,
}

export default SideFilterDemarcate
